import React, { useEffect, useState } from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import axiosInstance from './config/axiosConfig';
import {
  Box,
  Button,
  Drawer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  TextField,
  Checkbox,
  FormControlLabel,
  Pagination,
  Menu
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import GetAppIcon from "@mui/icons-material/GetApp";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import SearchIcon from "@mui/icons-material/Search";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import * as XLSX from "xlsx";

export default function DataCollected() {
  const apiRef = useGridApiRef();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [openFilters, setOpenFilters] = useState(false);
  const [openColumns, setOpenColumns] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const [submenu, setSubmenu] = useState(null);
  const [page, setPage] = useState(0);
  const pageSize = 20;

  // Mapeo de departamentos
  const departamentosMap = {
    16: "Alta Verapaz",
    15: "Baja Verapaz",
    4: "Chimaltenango",
    20: "Chiquimula",
    2: "El Progreso",
    5: "Escuintla",
    1: "Guatemala",
    13: "Huehuetenango",
    18: "Izabal",
    21: "Jalapa",
    22: "Jutiapa",
    17: "Petén",
    9: "Quetzaltenango",
    14: "Quiché",
    11: "Retalhuleu",
    3: "Sacatepéquez",
    12: "San Marcos",
    6: "Santa Rosa",
    7: "Sololá",
    10: "Suchitepéquez",
    8: "Totonicapán",
    19: "Zacapa"
  };

  // Mapeo de municipios
const municipiosMap = {
  1612: { nombre: "Santa María Cahabón", departamento: 16 },
  1609: { nombre: "San Pedro Carchá", departamento: 16 },
  1614: { nombre: "Chahal", departamento: 16 },
  1613: { nombre: "Chisec", departamento: 16 },
  1601: { nombre: "Cobán", departamento: 16 },
  1615: { nombre: "Fray Bartolomé De Las Casas", departamento: 16 },
  1611: { nombre: "Lanquín", departamento: 16 },
  1607: { nombre: "Panzós", departamento: 16 },
  1617: { nombre: "Raxruhá", departamento: 16 },
  1603: { nombre: "San Cristóbal Verapaz", departamento: 16 },
  1610: { nombre: "San Juan Chamelco", departamento: 16 },
  1616: { nombre: "Santa Catalina la Tinta", departamento: 16 },
  1602: { nombre: "Santa Cruz Verapaz", departamento: 16 },
  1608: { nombre: "Senahú", departamento: 16 },
  1604: { nombre: "Tactic", departamento: 16 },
  1605: { nombre: "Tamahú", departamento: 16 },
  1606: { nombre: "Tucurú", departamento: 16 },

  1504: { nombre: "Cubulco", departamento: 15 },
  1506: { nombre: "Santa Cruz El Chol", departamento: 15 },
  1505: { nombre: "Granados", departamento: 15 },
  1508: { nombre: "Purulhá", departamento: 15 },
  1503: { nombre: "Rabinal", departamento: 15 },
  1501: { nombre: "Salamá", departamento: 15 },
  1507: { nombre: "San Jerónimo", departamento: 15 },
  1502: { nombre: "San Miguel Chicaj", departamento: 15 },

  411: { nombre: "Acatenango", departamento: 4 },
  401: { nombre: "Chimaltenango", departamento: 4 },
  404: { nombre: "Comalapa", departamento: 4 },
  416: { nombre: "El Tejar", departamento: 4 },
  406: { nombre: "Tecpán Guatemala", departamento: 4 },
  414: { nombre: "Parramos", departamento: 4 },
  409: { nombre: "Patzicía", departamento: 4 },
  407: { nombre: "Patzún", departamento: 4 },
  408: { nombre: "Pochuta", departamento: 4 },
  413: { nombre: "San Andrés Itzapa", departamento: 4 },
  402: { nombre: "San José Poaquil", departamento: 4 },
  403: { nombre: "San Martín Jilotepeque", departamento: 4 },
  405: { nombre: "Santa Apolonia", departamento: 4 },
  410: { nombre: "Santa Cruz Balanyá", departamento: 4 },
  412: { nombre: "Yepocapa", departamento: 4 },
  415: { nombre: "Zaragoza", departamento: 4 },

  2005: { nombre: "Camotán", departamento: 20 },
  2001: { nombre: "Chiquimula", departamento: 20 },
  2008: { nombre: "Concepción Las Minas", departamento: 20 },
  2007: { nombre: "Esquipulas", departamento: 20 },
  2011: { nombre: "Ipala", departamento: 20 },
  2004: { nombre: "Jocotán", departamento: 20 },
  2006: { nombre: "Olopa", departamento: 20 },
  2009: { nombre: "Quetzaltepeque", departamento: 20 },
  2010: { nombre: "San Jacinto", departamento: 20 },
  2002: { nombre: "San José La Arada", departamento: 20 },
  2003: { nombre: "San Juan Ermita", departamento: 20 },

  205: { nombre: "El Jícaro", departamento: 2 },
  201: { nombre: "Guastatoya", departamento: 2 },
  202: { nombre: "Morazán", departamento: 2 },
  203: { nombre: "San Agustín Acasaguastlán", departamento: 2 },
  208: { nombre: "San Antonio La Paz", departamento: 2 },
  204: { nombre: "San Cristóbal Acasaguastlán", departamento: 2 },
  207: { nombre: "Sanarate", departamento: 2 },
  206: { nombre: "Sansare", departamento: 2 },

  501: { nombre: "Escuintla", departamento: 5 },
  508: { nombre: "Guanagazapa", departamento: 5 },
  510: { nombre: "Iztapa", departamento: 5 },
  503: { nombre: "La Democracia", departamento: 5 },
  507: { nombre: "La Gomera", departamento: 5 },
  505: { nombre: "Masagua", departamento: 5 },
  513: { nombre: "Nueva Concepción", departamento: 5 },
  511: { nombre: "Palín", departamento: 5 },
  512: { nombre: "San Vicente Pacaya", departamento: 5 },
  509: { nombre: "San José", departamento: 5 },
  502: { nombre: "Santa Lucía Cotzumalguapa", departamento: 5 },
  514: { nombre: "Sipacate", departamento: 5 },
  504: { nombre: "Siquinalá", departamento: 5 },
  506: { nombre: "Tiquisate", departamento: 5 },

  101: { nombre: "Guatemala", departamento: 1 },
  112: { nombre: "Chuarrancho", departamento: 1 },
  110: { nombre: "San Juan Sacatepéquez", departamento: 1 },
  108: { nombre: "Mixco", departamento: 1 },
  109: { nombre: "San Pedro Sacatepéquez", departamento: 1 },
  111: { nombre: "San Raymundo", departamento: 1 },
  106: { nombre: "Chinautla", departamento: 1 },
  113: { nombre: "Fraijanes", departamento: 1 },
  105: { nombre: "Palencia", departamento: 1 },
  104: { nombre: "San José Del Golfo", departamento: 1 },
  103: { nombre: "San José Pinula", departamento: 1 },
  107: { nombre: "San Pedro Ayampuc", departamento: 1 },
  102: { nombre: "Santa Catarina Pinula", departamento: 1 },
  114: { nombre: "Amatitlán", departamento: 1 },
  116: { nombre: "Villa Canales", departamento: 1 },
  115: { nombre: "Villa Nueva", departamento: 1 },
  117: { nombre: "Petapa", departamento: 1 },

  1327: { nombre: "Aguacatán", departamento: 13 },
  1326: { nombre: "Santa Cruz Barillas", departamento: 13 },
  1302: { nombre: "Chiantla", departamento: 13 },
  1319: { nombre: "Colotenango", departamento: 13 },
  1322: { nombre: "Concepción Huista", departamento: 13 },
  1304: { nombre: "Cuilco", departamento: 13 },
  1301: { nombre: "Huehuetenango", departamento: 13 },
  1307: { nombre: "Jacaltenango", departamento: 13 },
  1312: { nombre: "La Democracia", departamento: 13 },
  1311: { nombre: "La Libertad", departamento: 13 },
  1303: { nombre: "Malacatancito", departamento: 13 },
  1305: { nombre: "Nentón", departamento: 13 },
  1324: { nombre: "San Antonio Huista", departamento: 13 },
  1329: { nombre: "San Gaspar Ixchil", departamento: 13 },
  1309: { nombre: "San Ildefonso Ixtahuacán", departamento: 13 },
  1316: { nombre: "San Juan Atitán", departamento: 13 },
  1323: { nombre: "San Juan Ixcoy", departamento: 13 },
  1318: { nombre: "San Mateo Ixtatán", departamento: 13 },
  1313: { nombre: "San Miguel Acatán", departamento: 13 },
  1306: { nombre: "San Pedro Necta", departamento: 13 },
  1314: { nombre: "San Rafael La Independencia", departamento: 13 },
  1328: { nombre: "San Rafael Petzal", departamento: 13 },
  1325: { nombre: "San Sebastián Coatán", departamento: 13 },
  1320: { nombre: "San Sebastián Huehuetenango", departamento: 13 },
  1331: { nombre: "Santa Ana Huista", departamento: 13 },
  1015: { nombre: "Santa Bárbara", departamento: 13 },
  1317: { nombre: "Santa Eulalia", departamento: 13 },
  1330: { nombre: "Santiago Chimaltenango", departamento: 13 },
  1333: { nombre: "Santiago Petatán", departamento: 13 },
  1308: { nombre: "Soloma", departamento: 13 },
  1321: { nombre: "Tectitán", departamento: 13 },
  1315: { nombre: "Todos Santos Cuchumatán", departamento: 13 },
  1332: { nombre: "Unión Cantinil", departamento: 13 },

  1420: { nombre: "Ixcán", departamento: 14 },
  1405: { nombre: "Chajul", departamento: 14 },
  1413: { nombre: "Nebaj", departamento: 14 },
  1411: { nombre: "San Juan Cotzal", departamento: 14 },
  1404: { nombre: "Zacualpa", departamento: 14 },
  1418: { nombre: "Canillá", departamento: 14 },
  1419: { nombre: "Chicaman", departamento: 14 },
  1402: { nombre: "Chiché", departamento: 14 },
  1406: { nombre: "Chichicastenango", departamento: 14 },
  1403: { nombre: "Chinique", departamento: 14 },
  1410: { nombre: "Cunén", departamento: 14 },
  1412: { nombre: "Joyabaj", departamento: 14 },
  1415: { nombre: "Uspantán", departamento: 14 },
  1421: { nombre: "Pachalúm", departamento: 14 },
  1407: { nombre: "Patzité", departamento: 14 },
  1416: { nombre: "Sacapulas", departamento: 14 },
  1414: { nombre: "San Andrés Sajcabajá", departamento: 14 },
  1408: { nombre: "San Antonio Ilotenango", departamento: 14 },
  1417: { nombre: "San Bartolomé Jocotenango", departamento: 14 },
  1409: { nombre: "San Pedro Jocopilas", departamento: 14 },
  1401: { nombre: "Santa Cruz Del Quiché", departamento: 14 },

  1803: { nombre: "El Estor", departamento: 18 },
  1802: { nombre: "Livingston", departamento: 18 },
  1805: { nombre: "Los Amates", departamento: 18 },
  1804: { nombre: "Morales", departamento: 18 },
  1801: { nombre: "Puerto Barrios", departamento: 18 },

  2101: { nombre: "Jalapa", departamento: 21 },
  2107: { nombre: "Mataquescuintla", departamento: 21 },
  2106: { nombre: "Monjas", departamento: 21 },
  2105: { nombre: "San Carlos Alzatate", departamento: 21 },
  2103: { nombre: "San Luis Jilotepeque", departamento: 21 },
  2104: { nombre: "San Manuel Chaparrón", departamento: 21 },
  2102: { nombre: "San Pedro Pinula", departamento: 21 },

  2204: { nombre: "Agua Blanca", departamento: 22 },
  2205: { nombre: "Asunción Mita", departamento: 22 },
  2207: { nombre: "Atescatempa", departamento: 22 },
  2214: { nombre: "Moyuta", departamento: 22 },
  2211: { nombre: "Comapa", departamento: 22 },
  2213: { nombre: "Conguaco", departamento: 22 },
  2209: { nombre: "El Adelanto", departamento: 22 },
  2202: { nombre: "El Progreso", departamento: 22 },
  2212: { nombre: "Jalpatagua", departamento: 22 },
  2208: { nombre: "Jerez", departamento: 22 },
  2201: { nombre: "Jutiapa", departamento: 22 },
  2215: { nombre: "Pasaco", departamento: 22 },
  2217: { nombre: "Quezada", departamento: 22 },
  2216: { nombre: "San José Acatempa", departamento: 22 },
  2203: { nombre: "Santa Catarina Mita", departamento: 22 },
  2206: { nombre: "Yupiltepeque", departamento: 22 },
  2210: { nombre: "Zapotitlán", departamento: 22 },

  1701: { nombre: "Flores", departamento: 17 },
  1711: { nombre: "Melchor De Mencos", departamento: 17 },
  1703: { nombre: "San Benito", departamento: 17 },
  1706: { nombre: "San Francisco", departamento: 17 },
  1704: { nombre: "San Andrés", departamento: 17 },
  509:  { nombre: "San José", departamento: 17 },
  1311: { nombre: "La Libertad", departamento: 17 },
  1713: { nombre: "Las Cruces", departamento: 17 },
  1710: { nombre: "Sayaxché", departamento: 17 },
  1709: { nombre: "San Luis", departamento: 17 },
  1708: { nombre: "Dolores", departamento: 17 },
  1714: { nombre: "El Chal", departamento: 17 },
  1712: { nombre: "Poptún", departamento: 17 },
  1707: { nombre: "Santa Ana", departamento: 17 },

  913: { nombre: "Almolonga", departamento: 9 },
  906: { nombre: "Cabricán", departamento: 9 },
  907: { nombre: "Cajolá", departamento: 9 },
  914: { nombre: "Cantel", departamento: 9 },
  920: { nombre: "Coatepeque", departamento: 9 },
  917: { nombre: "Colomba", departamento: 9 },
  911: { nombre: "Concepción Chiquirichapa", departamento: 9 },
  919: { nombre: "El Palmar", departamento: 9 },
  922: { nombre: "Flores Costa Cuca", departamento: 9 },
  921: { nombre: "Génova", departamento: 9 },
  915: { nombre: "Huitán", departamento: 9 },
  923: { nombre: "La Esperanza", departamento: 9 },
  903: { nombre: "Olintepeque", departamento: 9 },
  924: { nombre: "Palestina De Los Altos", departamento: 9 },
  901: { nombre: "Quetzaltenango", departamento: 9 },
  902: { nombre: "Salcajá", departamento: 9 },
  904: { nombre: "San Carlos Sija", departamento: 9 },
  918: { nombre: "San Francisco La Unión", departamento: 9 },
  909: { nombre: "Ostuncalco", departamento: 9 },
  912: { nombre: "San Martín Sacatepéquez", departamento: 9 },
  910: { nombre: "San Mateo", departamento: 9 },
  908: { nombre: "San Miguel Sigüilá", departamento: 9 },
  905: { nombre: "Sibilia", departamento: 9 },
  916: { nombre: "Zunil", departamento: 9 },

  1101: { nombre: "Retalhuleu", departamento: 11 },
  1107: { nombre: "Champerico", departamento: 11 },
  1109: { nombre: "El Asintal", departamento: 11 },
  1106: { nombre: "San Andrés Villa Seca", departamento: 11 },
  1108: { nombre: "Nuevo San Carlos", departamento: 11 },
  1105: { nombre: "San Felipe", departamento: 11 },
  1104: { nombre: "San Martín Zapotitlán", departamento: 11 },
  1102: { nombre: "San Sebastián", departamento: 11 },
  1103: { nombre: "Santa Cruz Muluá", departamento: 11 },

  314: { nombre: "Alotenango", departamento: 3 },
  312: { nombre: "Ciudad Vieja", departamento: 3 },
  315: { nombre: "San Antonio Aguas Calientes", departamento: 3 },
  313: { nombre: "San Miguel Dueñas", departamento: 3 },
  316: { nombre: "Santa Catarina Barahona", departamento: 3 },
  301: { nombre: "Antigua Guatemala", departamento: 3 },
  302: { nombre: "Jocotenango", departamento: 3 },
  303: { nombre: "Pastores", departamento: 3 },
  311: { nombre: "Santa María De Jesús", departamento: 3 },
  310: { nombre: "Magdalena Milpas Altas", departamento: 3 },
  308: { nombre: "San Lucas Sacatepéquez", departamento: 3 },
  309: { nombre: "Santa Lucía Milpas Altas", departamento: 3 },
  306: { nombre: "Santiago Sacatepéquez", departamento: 3 },
  307: { nombre: "San Bartolomé Milpas Altas", departamento: 3 },
  305: { nombre: "Santo Domingo Xenacoj", departamento: 3 },
  304: { nombre: "Sumpango", departamento: 3 },

  1217: { nombre: "Ayutla", departamento: 12 },
  1204: { nombre: "Comitancillo", departamento: 12 },
  1206: { nombre: "Concepción Tutuapa", departamento: 12 },
  1220: { nombre: "El Quetzal", departamento: 12 },
  1214: { nombre: "El Rodeo", departamento: 12 },
  1213: { nombre: "El Tumbador", departamento: 12 },
  1212: { nombre: "Nuevo Progreso", departamento: 12 },
  1223: { nombre: "Ixchiguan", departamento: 12 },
  1230: { nombre: "La Blanca", departamento: 12 },
  1221: { nombre: "La Reforma", departamento: 12 },
  1216: { nombre: "Catarina", departamento: 12 },
  1215: { nombre: "Malacatán", departamento: 12 },
  1218: { nombre: "Ocos", departamento: 12 },
  1222: { nombre: "Pajapita", departamento: 12 },
  1224: { nombre: "San José Ojetenam", departamento: 12 },
  1228: { nombre: "Río Blanco", departamento: 12 },
  1007: { nombre: "San Lorenzo", departamento: 12 },
  1225: { nombre: "San Cristobal Cucho", departamento: 12 },
  1201: { nombre: "San Marcos", departamento: 12 },
  1205: { nombre: "San Miguel Ixtahuacán", departamento: 12 },
  1219: { nombre: "San Pablo", departamento: 12 },
  1203: { nombre: "San Antonio Sacatepéquez", departamento: 12 },
  109:  { nombre: "San Pedro Sacatepéquez", departamento: 12 },
  1227: { nombre: "Esquipulas Palo Gordo", departamento: 12 },
  1211: { nombre: "San Rafaél Pie de la Cuesta", departamento: 12 },
  1208: { nombre: "San Sibinal", departamento: 12 },
  1226: { nombre: "Sipacapa", departamento: 12 },
  1207: { nombre: "Tacaná", departamento: 12 },
  1209: { nombre: "Tajumulco", departamento: 12 },
  1210: { nombre: "Tejutla", departamento: 12 },

  602: { nombre: "Barberena", departamento: 6 },
  604: { nombre: "Casillas", departamento: 6 },
  608: { nombre: "Chiquimulilla", departamento: 6 },
  601: { nombre: "Cuilapa", departamento: 6 },
  611: { nombre: "Guazacapán", departamento: 6 },
  614: { nombre: "Nueva Santa Rosa", departamento: 6 },
  606: { nombre: "Oratorio", departamento: 6 },
  613: { nombre: "Pueblo Nuevo Viñas", departamento: 6 },
  607: { nombre: "San Juan Tecuaco", departamento: 6 },
  605: { nombre: "San Rafaél Las Flores", departamento: 6 },
  612: { nombre: "Santa Cruz Naranjo", departamento: 6 },
  610: { nombre: "Santa María Ixhuatán", departamento: 6 },
  603: { nombre: "Santa Rosa De Lima", departamento: 6 },
  609: { nombre: "Taxisco", departamento: 6 },

  701: { nombre: "Sololá", departamento: 7 },
  708: { nombre: "Concepción", departamento: 7 },
  706: { nombre: "Santa Catarina Ixtahuacan", departamento: 7 },
  705: { nombre: "Nahualá", departamento: 7 },
  710: { nombre: "Panajachel", departamento: 7 },
  709: { nombre: "San Andrés Semetabaj", departamento: 7 },
  712: { nombre: "San Antonio Palopó", departamento: 7 },
  702: { nombre: "San José Chacayá", departamento: 7 },
  717: { nombre: "San Juan La Laguna", departamento: 7 },
  713: { nombre: "San Lucas Tolimán", departamento: 7 },
  716: { nombre: "San Marcos La Laguna", departamento: 7 },
  715: { nombre: "San Pablo La Laguna", departamento: 7 },
  718: { nombre: "San Pedro La Laguna", departamento: 7 },
  711: { nombre: "Santa Catarina Palopó", departamento: 7 },
  707: { nombre: "Santa Clara La Laguna", departamento: 7 },
  714: { nombre: "Santa Cruz La Laguna", departamento: 7 },
  704: { nombre: "Santa Lucía Utatlán", departamento: 7 },
  703: { nombre: "Santa María Visitación", departamento: 7 },
  719: { nombre: "Santiago Atitlán", departamento: 7 },

  1013: { nombre: "Chicacao", departamento: 10 },
  1002: { nombre: "Cuyotenango", departamento: 10 },
  1021: { nombre: "San José La Máquina", departamento: 10 },
  1001: { nombre: "Mazatenango", departamento: 10 },
  1003: { nombre: "San Francisco Zapotitlán", departamento: 10 },
  1012: { nombre: "San Gabriel", departamento: 10 },
  1007: { nombre: "San Lorenzo", departamento: 10 },
  1014: { nombre: "Patulul", departamento: 10 },
  1016: { nombre: "San Juan Bautista", departamento: 10 },
  1019: { nombre: "Pueblo Nuevo", departamento: 10 },
  1018: { nombre: "Zunilito", departamento: 10 },
  1020: { nombre: "Río Bravo", departamento: 10 },
  1010: { nombre: "San Antonio Suchitepéquez", departamento: 10 },
  1004: { nombre: "San Bernardino", departamento: 10 },
  1011: { nombre: "San Miguel Panán", departamento: 10 },
  1005: { nombre: "San José El Idolo", departamento: 10 },
  1015: { nombre: "Santa Bárbara", departamento: 10 },
  1006: { nombre: "Santo Domingo Suchitepequez", departamento: 10 },
  1008: { nombre: "Samayac", departamento: 10 },
  1009: { nombre: "San Pablo Jocopilas", departamento: 10 },
  1017: { nombre: "Santo Tomás La Unión", departamento: 10 },

  805: { nombre: "Momostenango", departamento: 8 },
  804: { nombre: "San Andrés Xecul", departamento: 8 },
  808: { nombre: "San Bartolo", departamento: 8 },
  802: { nombre: "San Cristóbal Totonicapán", departamento: 8 },
  803: { nombre: "San Francisco El Alto", departamento: 8 },
  807: { nombre: "Santa Lucía La Reforma", departamento: 8 },
  806: { nombre: "Santa María Chiquimula", departamento: 8 },
  801: { nombre: "Totonicapán", departamento: 8 },

  1907: { nombre: "Cabañas", departamento: 19 },
  1902: { nombre: "Estanzuela", departamento: 19 },
  1904: { nombre: "Gualán", departamento: 19 },
  1910: { nombre: "Huité", departamento: 19 },
  1909: { nombre: "La Unión", departamento: 19 },
  1903: { nombre: "Río Hondo", departamento: 19 },
  1908: { nombre: "San Diego", departamento: 19 },
  1911: { nombre: "San Jorge", departamento: 19 },
  1905: { nombre: "Teculután", departamento: 19 },
  1906: { nombre: "Usumatlán", departamento: 19 },
  1901: { nombre: "Zacapa", departamento: 19 }
};


  // Estados para filtros actualizados
  const [uniqueDepartamentos, setUniqueDepartamentos] = useState([]);
  const [uniqueMunicipios, setUniqueMunicipios] = useState([]);
  const [uniqueAnios, setUniqueAnios] = useState([]);
  const [uniqueCuatrimestres, setUniqueCuatrimestres] = useState([]);
  const [uniqueMonitores, setUniqueMonitores] = useState([]);

  const [selectedDepto, setSelectedDepto] = useState([]);
  const [selectedMuni, setSelectedMuni] = useState([]);
  const [selectedAnio, setSelectedAnio] = useState([]);
  const [selectedCuatrimestre, setSelectedCuatrimestre] = useState([]);
  const [selectedMonitor, setSelectedMonitor] = useState([]);

  // Función para obtener nombre de departamento
  const getDepartamentoNombre = (codigo) => {
    return departamentosMap[codigo] || `Departamento ${codigo}`;
  };

  // Función para obtener nombre de municipio  
  const getMunicipioNombre = (codigo) => {
    return municipiosMap[codigo]?.nombre || `Municipio ${codigo}`;
  };

// Tabla actualizada con mapeo de nombres según nuevas variables
const [columns, setColumns] = useState([
  { field: 'objectid', headerName: 'ID', width: 70, disableColumnMenu: true },
  { field: 'globalid', headerName: 'Global ID', minWidth: 200, flex: 1, disableColumnMenu: true },
  { 
    field: 'fecha_monitoreo',
    headerName: 'Fecha Monitoreo',
    minWidth: 120, flex: 1,
    disableColumnMenu: true,
    valueFormatter: (value) => {
      if (!value) return '';
      const [date] = value.split(' ');
      const [y, m, d] = date.split('-');
      return `${d}-${m}-${y}`;
      }
  },
  { 
    field: 'departamento', 
    headerName: 'Departamento', 
    minWidth: 150, 
    flex: 1, 
    disableColumnMenu: true,
    renderCell: (params) => getDepartamentoNombre(params.value)
  },
  { field: 'cod_departamento', headerName: 'Código Departamento', minWidth: 100, flex: 1, disableColumnMenu: true },
  { 
    field: 'municipio', 
    headerName: 'Municipio', 
    minWidth: 150, 
    flex: 1, 
    disableColumnMenu: true,
    renderCell: (params) => getMunicipioNombre(params.value)
  },
  { field: 'cod_municipio', headerName: 'Código Municipio', minWidth: 100, flex: 1, disableColumnMenu: true },
  { field: 'monitor', headerName: 'Monitor', minWidth: 150, flex: 1, disableColumnMenu: true },
  { field: 'cod_monitor', headerName: 'Código Monitor', minWidth: 100, flex: 1, disableColumnMenu: true },
  { field: 'mes_num', headerName: 'Mes', width: 80, disableColumnMenu: true },
  { field: 'bimestre', headerName: 'Bimestre', width: 100, disableColumnMenu: true },
  { field: 'cuatrimestre', headerName: 'Cuatrimestre', width: 120, disableColumnMenu: true },
  { field: 'anio', headerName: 'Año', width: 80, disableColumnMenu: true },
  
  // Campos de asistencia P1
  { field: 'p1_asistentes', headerName: 'Asistentes regulares', width: 120, disableColumnMenu: true },
  { field: 'p1_1_asistentes', headerName: 'Asistentes Instituciones Gov', minWidth: 180, flex: 1, disableColumnMenu: true },
  { field: 'p1_total_instituciones', headerName: 'Total Instituciones P1', width: 150, disableColumnMenu: true },
  { field: 'p1_denominador', headerName: 'Número Convocados P1', width: 150, disableColumnMenu: true },
  { field: 'p1_numerador', headerName: 'Numerador P1', width: 120, disableColumnMenu: true },
  { field: 'p1_porcentaje', headerName: 'P1 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p1_nivel', headerName: 'P1 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P2 - Participación ONG
  { field: 'p2_asociaciones', headerName: 'Número Asociaciones', width: 130, disableColumnMenu: true },
  { field: 'p2_sociedad_civil', headerName: 'Número Sociedad Civil', width: 140, disableColumnMenu: true },
  { field: 'p2_organismos_internacionales', headerName: 'Organismos Internacionales', width: 160, disableColumnMenu: true },
  { field: 'p2_numerador', headerName: 'Numerador P2', width: 120, disableColumnMenu: true },
  { field: 'p2_denominador', headerName: 'Convocados ONG P2', width: 140, disableColumnMenu: true },
  { field: 'p2_porcentaje', headerName: 'P2 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p2_nivel', headerName: 'P2 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P3 - Participación OSC
  { field: 'p3_numerador', headerName: 'Instituciones que Presentan P3', width: 180, disableColumnMenu: true },
  { field: 'p3_denominador', headerName: 'Convocadas P3', width: 130, disableColumnMenu: true },
  { field: 'p3_porcentaje', headerName: 'P3 Porcentaje (%)', width: 120, disableColumnMenu: true },
  
  // Indicadores P4 - Equidad
  { field: 'p4_mujeres_embarazadas', headerName: 'Mujeres Embarazadas', width: 150, disableColumnMenu: true },
  { field: 'p4_infantes_m5', headerName: 'Niños Menores 5 años', width: 140, disableColumnMenu: true },
  { field: 'p4_migrantes', headerName: 'Migrantes', width: 100, disableColumnMenu: true },
  { field: 'p4_adulto_mayor', headerName: 'Adultos Mayores', width: 120, disableColumnMenu: true },
  { field: 'p4_adolescentes', headerName: 'Adolescentes', width: 120, disableColumnMenu: true },
  { field: 'p4_otros', headerName: 'Otros Vulnerables', width: 130, disableColumnMenu: true },
  { field: 'p4_total_poblacion_vulnerable', headerName: 'Total Población Vulnerable', width: 160, disableColumnMenu: true },
  { field: 'p4_numerador', headerName: 'Vulnerable con Acciones P4', width: 160, disableColumnMenu: true },
  { field: 'p4_denominador', headerName: 'Total Vulnerable P4', width: 140, disableColumnMenu: true },
  { field: 'p4_porcentaje', headerName: 'P4 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p4_nivel', headerName: 'P4 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P5 - Capacidad Respuesta
  { field: 'p5_numero_planes', headerName: 'Planes Municipales P5', width: 150, disableColumnMenu: true },
  { field: 'p5_porcentaje', headerName: 'P5 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p5_nivel', headerName: 'P5 Nivel', width: 100, disableColumnMenu: true },

  // Indicadores P5A 
  { field: 'p5A_numerador', headerName: 'Estrategias en Planes P5A', width: 160, disableColumnMenu: true },
  { field: 'p5A_denominador', headerName: 'Estrategias Gubernamentales P5A', width: 170, disableColumnMenu: true },
  { field: 'p5A_porcentaje', headerName: 'P5A Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p5A_nivel', headerName: 'P5A Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P6
  { field: 'p6_numerador', headerName: 'Informes Elaborados P6', width: 150, disableColumnMenu: true },
  { field: 'p6_denominador', headerName: 'Informes Planificados P6', width: 150, disableColumnMenu: true },
  { field: 'p6_porcentaje', headerName: 'P6 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p6_nivel', headerName: 'P6 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P7
  { field: 'p7_protocolos_activados', headerName: 'Protocolos Activados', width: 140, disableColumnMenu: true },
  { field: 'p7_numero_protocolos', headerName: 'Número Protocolos', width: 130, disableColumnMenu: true },
  { field: 'p7_PAC', headerName: 'Protocolo Actuación Conjunta', width: 160, disableColumnMenu: true },
  { field: 'p7_PIA', headerName: 'Protocolo Desnutrición Aguda', width: 160, disableColumnMenu: true },
  { field: 'p7_PHE', headerName: 'Protocolo Hambre Estacional', width: 160, disableColumnMenu: true },
  { field: 'p7_PSAN', headerName: 'Protocolo SAN Migrantes', width: 150, disableColumnMenu: true },
  { field: 'p7_PEDN', headerName: 'Emergencias Desastres Naturales', width: 160, disableColumnMenu: true },
  { field: 'p7_porcentaje', headerName: 'P7 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p7_nivel', headerName: 'P7 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P8
  { field: 'p8_CMSANA', headerName: 'Caracterización SAN Actualizada', width: 160, disableColumnMenu: true },
  { field: 'p8_porcentaje', headerName: 'P8 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p8_nivel', headerName: 'P8 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P9 - Coordinación
  { field: 'p9_numerador', headerName: 'Intervenciones Ejecutadas P9', width: 160, disableColumnMenu: true },
  { field: 'p9_denominador', headerName: 'Intervenciones Planificadas P9', width: 160, disableColumnMenu: true },
  { field: 'p9_porcentaje', headerName: 'P9 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p9_nivel', headerName: 'P9 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P10
  { field: 'p10_numero_monitores', headerName: 'Número Monitores SESAN', width: 150, disableColumnMenu: true },
  { field: 'p10_numero_personal', headerName: 'Personal Municipal SAN', width: 140, disableColumnMenu: true },
  { field: 'p10_ponderacion_SESAN', headerName: 'Métrica Ponderación P10', width: 150, disableColumnMenu: true },
  { field: 'p10_porcentaje', headerName: 'P10 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p10_nivel', headerName: 'P10 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P11 - Capacitaciones
  { field: 'p11_numerador', headerName: 'Capacitaciones Recibidas', width: 150, disableColumnMenu: true },
  { field: 'p11_denominador', headerName: 'Capacitaciones Planificadas', width: 160, disableColumnMenu: true },
  { field: 'p11_porcentaje', headerName: 'P11 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p11_nivel', headerName: 'P11 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P12 - Familias
  { field: 'p12_numerador', headerName: 'Familias con Intervenciones', width: 160, disableColumnMenu: true },
  { field: 'p12_denominador', headerName: 'Familias Diagnosticadas', width: 150, disableColumnMenu: true },
  { field: 'p12_porcentaje', headerName: 'P12 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p12_nivel', headerName: 'P12 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P13 - Mujeres Embarazadas
  { field: 'p13_numerador', headerName: 'Mujeres con Controles P13', width: 160, disableColumnMenu: true },
  { field: 'p13_denominador', headerName: 'Mujeres Embarazadas P13', width: 150, disableColumnMenu: true },
  { field: 'p13_porcentaje', headerName: 'P13 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p13_nivel', headerName: 'P13 Nivel', width: 100, disableColumnMenu: true },

  // Indicadores P13A - Mujeres Embarazadas con TMC
  { field: 'p13A_numerador', headerName: 'Mujeres con TMC P13A', width: 150, disableColumnMenu: true },
  { field: 'p13A_denominador', headerName: 'Mujeres Prioritarias P13A', width: 150, disableColumnMenu: true },
  { field: 'p13A_porcentaje', headerName: 'P13A Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p13A_nivel', headerName: 'P13A Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P14 - Acciones
  { field: 'p14_numerador', headerName: 'Acciones Ejecutadas', width: 140, disableColumnMenu: true },
  { field: 'p14_denominador', headerName: 'Acciones Planificadas', width: 140, disableColumnMenu: true },
  { field: 'p14_porcentaje', headerName: 'P14 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p14_nivel', headerName: 'P14 Nivel', width: 100, disableColumnMenu: true },
  
  // Indicadores P15 - Proyectos
  { field: 'p15_numerador', headerName: 'Proyectos Ejecutados', width: 140, disableColumnMenu: true },
  { field: 'p15_denominador', headerName: 'Proyectos en POA', width: 130, disableColumnMenu: true },
  { field: 'p15_porcentaje', headerName: 'P15 Porcentaje (%)', width: 120, disableColumnMenu: true },
  { field: 'p15_nivel', headerName: 'P15 Nivel', width: 100, disableColumnMenu: true },
  
  // Metadatos
  { 
    field: 'creationDate',
    headerName: 'Fecha Creación',
    minWidth: 120, flex: 1,
    disableColumnMenu: true,
    valueFormatter: (value) => {
      if (!value) return '';
      const [date, time] = value.split(' ');
      const [y, m, d] = date.split('-');
      return `${d}-${m}-${y} ${time}`;
      }
  },
  { field: 'creator', headerName: 'Creador', minWidth: 120, flex: 1, disableColumnMenu: true },
  { 
    field: 'editDate',
    headerName: 'Fecha Edición',
    minWidth: 120, flex: 1,
    disableColumnMenu: true,
    valueFormatter: (value) => {
      if (!value) return '';
      const [date, time] = value.split(' ');
      const [y, m, d] = date.split('-');
      return `${d}-${m}-${y} ${time}`;
      }
  },
  { field: 'editor', headerName: 'Editor', minWidth: 120, flex: 1, disableColumnMenu: true },
]);

const [columnVisibility, setColumnVisibility] = useState(
  columns.reduce((acc, col) => {
    // Por defecto, mostrar solo las columnas más importantes
    const visibleByDefault = [
      'objectid', 'monitor', 'fecha_monitoreo', 'departamento', 'municipio', 
      'anio', 'mes_num', 'p1_porcentaje', 'p2_porcentaje', 'p3_porcentaje',
      'p4_porcentaje', 'p5_porcentaje', 'p5A_porcentaje', 'p6_porcentaje', 'p7_porcentaje', 
      'p8_porcentaje', 'p9_porcentaje', 'p10_porcentaje', 'p11_porcentaje', 'p12_porcentaje',
      'p13_porcentaje', 'p13A_porcentaje', 'p14_porcentaje', 'p15_porcentaje'
    ];
    acc[col.field] = visibleByDefault.includes(col.field);
    return acc;
  }, {})
);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenu(null);
  };

  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.get('/NuevoUser');
      const data = response.data;
      
      setRows(data);
      setFilteredRows(data);

      const uniqueDeptos = [...new Set(data.map((r) => r.departamento))]
        .sort()
        .map(codigo => ({ codigo, nombre: getDepartamentoNombre(codigo) }));
      
      const uniqueMunis = [...new Set(data.map((r) => r.municipio))]
        .sort()
        .map(codigo => ({ codigo, nombre: getMunicipioNombre(codigo) }));

      setUniqueDepartamentos(uniqueDeptos);
      setUniqueMunicipios(uniqueMunis);
      setUniqueAnios([...new Set(data.map((r) => r.anio))].sort());
      setUniqueCuatrimestres([...new Set(data.map((r) => r.cuatrimestre))].sort());
      setUniqueMonitores([...new Set(data.map((r) => r.monitor))].sort());
    } catch (err) {
      console.error('Error al obtener datos:', err);
    }
  };

  fetchData();
}, []);

  // aplicar filtros y búsqueda
  useEffect(() => {
    let filtered = rows;

    if (selectedDepto.length > 0) {
      filtered = filtered.filter((row) =>
        selectedDepto.includes(row.departamento)
      );
    }
    if (selectedMuni.length > 0) {
      filtered = filtered.filter((row) =>
        selectedMuni.includes(row.municipio)
      );
    }
    if (selectedAnio.length > 0) {
      filtered = filtered.filter((row) =>
        selectedAnio.includes(row.anio)
      );
    }
    if (selectedCuatrimestre.length > 0) {
      filtered = filtered.filter((row) =>
        selectedCuatrimestre.includes(row.cuatrimestre)
      );
    }
    if (selectedMonitor.length > 0) {
      filtered = filtered.filter((row) =>
        selectedMonitor.includes(row.monitor)
      );
    }

    // filtro de búsqueda
    if (searchText) {
      const lowerSearch = searchText.toLowerCase();
      filtered = filtered.filter((row) =>
        columns.some(
          (col) => {
            if (!columnVisibility[col.field]) return false;
            
            let value = row[col.field];
            // Para departamento y municipio, buscar también en los nombres
            if (col.field === 'departamento') {
              value = getDepartamentoNombre(row.departamento);
            } else if (col.field === 'municipio') {
              value = getMunicipioNombre(row.municipio);
            }
            
            return String(value || "").toLowerCase().includes(lowerSearch);
          }
        )
      );
    }

    setFilteredRows(filtered);
  }, [
    rows,
    selectedDepto,
    selectedMuni,
    selectedAnio,
    selectedCuatrimestre,
    selectedMonitor,
    searchText,
    columnVisibility,
  ]);

const handleExportCSV = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") {
    dataToExport = filteredRows;
  } else if (type === "page") {
    const start = page * pageSize;
    const end = start + pageSize;
    dataToExport = filteredRows.slice(start, end);
  } else if (type === "selected") {
    dataToExport = selectedData || [];
  }

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  const csvContent = [
    visibleColumns.map((c) => c.headerName).join(","),
    ...dataToExport.map((row) =>
      visibleColumns.map((c) => {
        let value = row[c.field];
        // Exportar nombres en lugar de códigos
        if (c.field === 'departamento') {
          value = getDepartamentoNombre(row.departamento);
        } else if (c.field === 'municipio') {
          value = getMunicipioNombre(row.municipio);
        }
        return value;
      }).join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "datos_monitoreo.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleExportXLSX = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") {
    dataToExport = filteredRows;
  } else if (type === "page") {
    const start = page * pageSize;
    const end = start + pageSize;
    dataToExport = filteredRows.slice(start, end);
  } else if (type === "selected") {
    dataToExport = selectedData || [];
  }

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  const exportData = dataToExport.map((row) => {
    const obj = {};
    visibleColumns.forEach((col) => {
      let value = row[col.field];
      // Exportar nombres en lugar de códigos
      if (col.field === 'departamento') {
        value = getDepartamentoNombre(row.departamento);
      } else if (col.field === 'municipio') {
        value = getMunicipioNombre(row.municipio);
      }
      obj[col.headerName] = value;
    });
    return obj;
  });

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Datos");

  XLSX.writeFile(wb, "datos_monitoreo.xlsx");
};

const handleExportWord = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") dataToExport = filteredRows;
  else if (type === "page") dataToExport = filteredRows.slice(page * pageSize, (page + 1) * pageSize);
  else if (type === "selected") dataToExport = selectedData || [];

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  let htmlContent = "<table border='1'><thead><tr>";
  visibleColumns.forEach((col) => { htmlContent += `<th>${col.headerName}</th>`; });
  htmlContent += "</tr></thead><tbody>";
  dataToExport.forEach((row) => {
    htmlContent += "<tr>";
    visibleColumns.forEach((col) => { 
      let value = row[col.field];
      // Exportar nombres en lugar de códigos
      if (col.field === 'departamento') {
        value = getDepartamentoNombre(row.departamento);
      } else if (col.field === 'municipio') {
        value = getMunicipioNombre(row.municipio);
      }
      htmlContent += `<td>${value}</td>`; 
    });
    htmlContent += "</tr>";
  });
  htmlContent += "</tbody></table>";

  const blob = new Blob([htmlContent], { type: "application/msword" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "datos_monitoreo.doc");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleExportXML = (type, selectedData = null) => {
  let dataToExport = [];

  if (type === "all") dataToExport = filteredRows;
  else if (type === "page") dataToExport = filteredRows.slice(page * pageSize, (page + 1) * pageSize);
  else if (type === "selected") dataToExport = selectedData || [];

  const visibleColumns = columns.filter((c) => columnVisibility[c.field]);

  let xmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n<rows>\n';
  dataToExport.forEach((row) => {
    xmlContent += "  <row>\n";
    visibleColumns.forEach((col) => {
      let value = row[col.field];
      // Exportar nombres en lugar de códigos
      if (col.field === 'departamento') {
        value = getDepartamentoNombre(row.departamento);
      } else if (col.field === 'municipio') {
        value = getMunicipioNombre(row.municipio);
      }
      xmlContent += `    <${col.field}>${value}</${col.field}>\n`;
    });
    xmlContent += "  </row>\n";
  });
  xmlContent += "</rows>";

  const blob = new Blob([xmlContent], { type: "application/xml" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "datos_monitoreo.xml");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const filteredMunicipios =
    selectedDepto.length > 0
      ? uniqueMunicipios.filter(muni => 
          municipiosMap[muni.codigo] && selectedDepto.includes(municipiosMap[muni.codigo].departamento)
        )
      : uniqueMunicipios;

  return (
    <div style={{ height: "90%", width: "100%", overflowX: "auto", padding: "10px" }}>
      {/* Toolbar */}
      <Box sx={{ display: "flex", gap: 2, marginBottom: 2, flexWrap: "wrap" }}>
        <Button
          variant="outlined"
          startIcon={<FilterListIcon />}
          onClick={() => setOpenFilters(true)}
        >
          Filtros
        </Button>

        {/* Botón Exportar como menú */}
        <Button
          variant="outlined"
          startIcon={<GetAppIcon />}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          Exportar
        </Button>

<Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleMenuClose}
>
  {["all", "page", "selected"].map((type) => (
    <MenuItem
      key={type}
      onMouseEnter={() => setSubmenu(type)}
      onMouseLeave={() => setSubmenu(null)}
    >
      {type === "all" && "Todos los registros"}
      {type === "page" && "Solo la página actual"}
      {type === "selected" && "Datos seleccionados"}

      <ArrowRightIcon fontSize="small" style={{ marginLeft: "auto" }} />

      {submenu === type && (
        <Menu
          anchorEl={anchorEl}
          open
          onClose={() => setSubmenu(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={() => {
          if (type === "selected") {
            const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
            handleExportCSV("selected", selectedRows);
          } else {
            handleExportCSV(type);
          }
          handleMenuClose();
        }}>CSV</MenuItem>

          <MenuItem onClick={() => {
  if (type === "selected") {
    const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
    handleExportXLSX("selected", selectedRows);
  } else {
    handleExportXLSX(type);
  }
  handleMenuClose();
}}>Excel</MenuItem>

          <MenuItem onClick={() => {
  if (type === "selected") {
    const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
    handleExportWord("selected", selectedRows);
  } else {
    handleExportWord(type);
  }
  handleMenuClose();
}}>Word</MenuItem>
          <MenuItem onClick={() => {
  if (type === "selected") {
    const selectedRows = Array.from(apiRef.current.getSelectedRows().values());
    handleExportXML("selected", selectedRows);
  } else {
    handleExportXML(type);
  }
  handleMenuClose();
}}>XML</MenuItem>
        </Menu>
      )}
    </MenuItem>
  ))}
</Menu>

        <TextField
          size="small"
          placeholder="Buscar..."
          InputProps={{
            startAdornment: <SearchIcon />,
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <Button
          variant="outlined"
          startIcon={<ViewColumnIcon />}
          onClick={() => setOpenColumns(true)}
        >
          Columnas
        </Button>
      </Box>

      {/* Drawer para filtros */}
      <Drawer anchor="right" open={openFilters} onClose={() => setOpenFilters(false)}>
        <Box sx={{ width: 300, p: 2 }}>
          <h3>Filtros</h3>

          {/* Departamento */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Departamento</InputLabel>
            <Select
              multiple
              value={selectedDepto}
              onChange={(e) => {
                setSelectedDepto(e.target.value);
                setSelectedMuni([]);
              }}
              input={<OutlinedInput label="Departamento" />}
            >
              {uniqueDepartamentos.map((dept) => (
                <MenuItem key={dept.codigo} value={dept.codigo}>
                  {dept.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Municipio */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Municipio</InputLabel>
            <Select
              multiple
              value={selectedMuni}
              onChange={(e) => setSelectedMuni(e.target.value)}
              input={<OutlinedInput label="Municipio" />}
              disabled={!filteredMunicipios.length}
            >
              {filteredMunicipios.map((muni) => (
                <MenuItem key={muni.codigo} value={muni.codigo}>
                  {muni.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Año */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Año</InputLabel>
            <Select
              multiple
              value={selectedAnio}
              onChange={(e) => setSelectedAnio(e.target.value)}
              input={<OutlinedInput label="Año" />}
            >
              {uniqueAnios.map((a, i) => (
                <MenuItem key={i} value={a}>
                  {a}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Cuatrimestre */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Cuatrimestre</InputLabel>
            <Select
              multiple
              value={selectedCuatrimestre}
              onChange={(e) => setSelectedCuatrimestre(e.target.value)}
              input={<OutlinedInput label="Cuatrimestre" />}
            >
              {uniqueCuatrimestres.map((c, i) => (
                <MenuItem key={i} value={c}>
                  {c}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Monitor */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Monitor</InputLabel>
            <Select
              multiple
              value={selectedMonitor}
              onChange={(e) => setSelectedMonitor(e.target.value)}
              input={<OutlinedInput label="Monitor" />}
            >
              {uniqueMonitores.map((m, i) => (
                <MenuItem key={i} value={m}>
                  {m}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ mb: 2 }}
            onClick={() => {
              setSelectedDepto([]);
              setSelectedMuni([]);
              setSelectedAnio([]);
              setSelectedCuatrimestre([]);
              setSelectedMonitor([]);
            }}
          >
            Limpiar filtros
          </Button>
        </Box>
      </Drawer>

      {/* Drawer de columnas */}
      <Drawer anchor="right" open={openColumns} onClose={() => setOpenColumns(false)}>
        <Box sx={{ width: 300, p: 2, maxHeight: '100vh', overflowY: 'auto' }}>
          <h3>Columnas</h3>
          {columns.map((col) => (
            <FormControlLabel
              key={col.field}
              control={
                <Checkbox
                  checked={columnVisibility[col.field]}
                  onChange={(e) =>
                    setColumnVisibility((prev) => ({
                      ...prev,
                      [col.field]: e.target.checked,
                    }))
                  }
                />
              }
              label={col.headerName}
              sx={{ display: 'block', mb: 1 }}
            />
          ))}
        </Box>
      </Drawer>

      {/* Tabla */}
      <div style={{ minWidth: 1800 }}>
        <DataGrid
          apiRef={apiRef}
          rows={filteredRows}
          columns={columns}
          columnVisibilityModel={columnVisibility}
          onColumnVisibilityModelChange={(newModel) => setColumnVisibility(newModel)}
          
          pagination
          pageSizeOptions={[10, 20, 50]}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => setPage(model.page)}
          checkboxSelection
          disableSelectionOnClick
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={Math.ceil(filteredRows.length / pageSize)}
          page={page + 1}
          onChange={(e, value) => setPage(value - 1)}
          color="primary"
          shape="rounded"
        />
      </Box>
      </div>
    </div>
  );
}